/**
 * Generated by orval 🍺
 * Do not edit manually.
 * IST.Connect | v1
 * REST API backing the IST Connect web frontend. Provides endpoints to manage plugin configurations and inspect task execution results, logs, and dashboard data.
 * OpenAPI spec version: 1.0.0
 */
import type {
	CreateUntisMdmConfigRequest,
	Errors,
	GetUntisMdmConfigsParams,
	GetUntisMdmTaskResultsParams,
	GetUntisMdmTasksParams,
	RequestUntisMdmSubstituteTeacherTaskParams,
	UntisMdmConfig,
	UntisMdmConfigCreatedResponse,
	UntisMdmConfigPage,
	UntisMdmTask,
	UntisMdmTaskPage,
	UntisMdmTaskRequestedResponse,
	UntisMdmTaskResultPage,
	UpdateUntisMdmConfigRequest,
} from "../model";

import { customFetch } from "../../customFetcher";

export const getCreateUntisMdmConfigUrl = () => {
	return `/istconnect-service-api/units-mdm-configs`;
};

/**
 * @summary Creates a new plugin config
 */
export const createUntisMdmConfig = async (
	createUntisMdmConfigRequest: CreateUntisMdmConfigRequest,
	options?: Parameters<typeof customFetch>[1],
): Promise<UntisMdmConfigCreatedResponse> => {
	const getHeaders = (h?: NonNullable<RequestInit["headers"]>): Record<string, string | readonly string[]> => {
		if (!h) return {};
		if (h instanceof Headers) return Object.fromEntries(h.entries());
		if (Symbol.iterator in h) {
			return Object.fromEntries(Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]));
		}
		const headers: Record<string, string | readonly string[]> = {};
		for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
			if (value !== undefined) headers[name] = value;
		}
		return headers;
	};
	return customFetch<UntisMdmConfigCreatedResponse>(getCreateUntisMdmConfigUrl(), {
		...options,
		method: "POST",
		headers: { "Content-Type": "application/json-patch+json", ...getHeaders(options?.headers) },
		body: JSON.stringify(createUntisMdmConfigRequest),
	});
};

export const getGetUntisMdmConfigsUrl = (params?: GetUntisMdmConfigsParams) => {
	const normalizedParams = new URLSearchParams();

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(key, value === null ? "null" : String(value));
		}
	});

	const stringifiedParams = normalizedParams.toString();

	return stringifiedParams.length > 0 ? `/istconnect-service-api/units-mdm-configs?${stringifiedParams}` : `/istconnect-service-api/units-mdm-configs`;
};

/**
 * @summary Get all UntisMdm configurations
 */
export const getUntisMdmConfigs = async (params?: GetUntisMdmConfigsParams, options?: Parameters<typeof customFetch>[1]): Promise<UntisMdmConfigPage> => {
	return customFetch<UntisMdmConfigPage>(getGetUntisMdmConfigsUrl(params), {
		...options,
		method: "GET",
	});
};

export const getDeleteUntisMdmConfigUrl = (id: string) => {
	return `/istconnect-service-api/units-mdm-configs/${id}`;
};

/**
 * @summary Deletes a UntisMdm plugin config
 */
export const deleteUntisMdmConfig = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<Errors> => {
	return customFetch<Errors>(getDeleteUntisMdmConfigUrl(id), {
		...options,
		method: "DELETE",
	});
};

export const getGetUntisMdmConfigUrl = (id: string) => {
	return `/istconnect-service-api/units-mdm-configs/${id}`;
};

/**
 * @summary get a untismdm plugin config
 */
export const getUntisMdmConfig = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<UntisMdmConfig> => {
	return customFetch<UntisMdmConfig>(getGetUntisMdmConfigUrl(id), {
		...options,
		method: "GET",
	});
};

export const getUpdateUntisMdmConfigUrl = (id: string) => {
	return `/istconnect-service-api/units-mdm-configs/${id}`;
};

/**
 * @summary Updates a untismdm plugin config
 */
export const updateUntisMdmConfig = async (
	id: string,
	updateUntisMdmConfigRequest: UpdateUntisMdmConfigRequest,
	options?: Parameters<typeof customFetch>[1],
): Promise<UntisMdmConfigCreatedResponse> => {
	const getHeaders = (h?: NonNullable<RequestInit["headers"]>): Record<string, string | readonly string[]> => {
		if (!h) return {};
		if (h instanceof Headers) return Object.fromEntries(h.entries());
		if (Symbol.iterator in h) {
			return Object.fromEntries(Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]));
		}
		const headers: Record<string, string | readonly string[]> = {};
		for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
			if (value !== undefined) headers[name] = value;
		}
		return headers;
	};
	return customFetch<UntisMdmConfigCreatedResponse>(getUpdateUntisMdmConfigUrl(id), {
		...options,
		method: "PATCH",
		headers: { "Content-Type": "application/json-patch+json", ...getHeaders(options?.headers) },
		body: JSON.stringify(updateUntisMdmConfigRequest),
	});
};

export const getGetUntisMdmTaskUrl = (id: string) => {
	return `/istconnect-service-api/units-mdm-tasks${id}`;
};

/**
 * @summary Get Untis MDM task details by ID
 */
export const getUntisMdmTask = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<UntisMdmTask> => {
	return customFetch<UntisMdmTask>(getGetUntisMdmTaskUrl(id), {
		...options,
		method: "GET",
	});
};

export const getGetUntisMdmTaskResultsUrl = (id: string, params?: GetUntisMdmTaskResultsParams) => {
	const normalizedParams = new URLSearchParams();

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(key, value === null ? "null" : String(value));
		}
	});

	const stringifiedParams = normalizedParams.toString();

	return stringifiedParams.length > 0
		? `/istconnect-service-api/units-mdm-tasks${id}/results?${stringifiedParams}`
		: `/istconnect-service-api/units-mdm-tasks${id}/results`;
};

/**
 * @summary Get a list of UntisMdm tasks results.
 */
export const getUntisMdmTaskResults = async (
	id: string,
	params?: GetUntisMdmTaskResultsParams,
	options?: Parameters<typeof customFetch>[1],
): Promise<UntisMdmTaskResultPage> => {
	return customFetch<UntisMdmTaskResultPage>(getGetUntisMdmTaskResultsUrl(id, params), {
		...options,
		method: "GET",
	});
};

export const getGetUntisMdmTasksUrl = (params?: GetUntisMdmTasksParams) => {
	const normalizedParams = new URLSearchParams();

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(key, value === null ? "null" : String(value));
		}
	});

	const stringifiedParams = normalizedParams.toString();

	return stringifiedParams.length > 0 ? `/istconnect-service-api/units-mdm-tasks?${stringifiedParams}` : `/istconnect-service-api/units-mdm-tasks`;
};

/**
 * @summary Get a list of UntisMdm tasks.
 */
export const getUntisMdmTasks = async (params?: GetUntisMdmTasksParams, options?: Parameters<typeof customFetch>[1]): Promise<UntisMdmTaskPage> => {
	return customFetch<UntisMdmTaskPage>(getGetUntisMdmTasksUrl(params), {
		...options,
		method: "GET",
	});
};

export const getRequestUntisMdmSubstituteTeacherTaskUrl = (id: string, params?: RequestUntisMdmSubstituteTeacherTaskParams) => {
	const normalizedParams = new URLSearchParams();

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(key, value === null ? "null" : String(value));
		}
	});

	const stringifiedParams = normalizedParams.toString();

	return stringifiedParams.length > 0
		? `/istconnect-service-api/units-mdm-configs/${id}/requests?${stringifiedParams}`
		: `/istconnect-service-api/units-mdm-configs/${id}/requests`;
};

/**
 * @summary Creates a request to execute a plugin config
 */
export const requestUntisMdmSubstituteTeacherTask = async (
	id: string,
	params?: RequestUntisMdmSubstituteTeacherTaskParams,
	options?: Parameters<typeof customFetch>[1],
): Promise<UntisMdmTaskRequestedResponse> => {
	return customFetch<UntisMdmTaskRequestedResponse>(getRequestUntisMdmSubstituteTeacherTaskUrl(id, params), {
		...options,
		method: "POST",
	});
};
